import { LoadButton, NoDataMessage, isNoData } from '../shared';
import { MarketValueIcon } from '../icons';
import type { UseQueryResult } from '@tanstack/react-query';

interface MarketValueTabProps {
  query: UseQueryResult<any>;
  loadEnabled: boolean;
  onLoad: () => void;
  disabled?: boolean;
}

export function MarketValueTab({ query, loadEnabled, onLoad, disabled }: MarketValueTabProps) {
  return (
    <div>
      {!loadEnabled && (
        <div className="flex flex-col items-center justify-center py-12">
          <MarketValueIcon className="w-12 h-12 opacity-40 mb-4" />
          <p className="text-gray-400 text-sm mb-4">Get trade-in, private party, and dealer retail values</p>
          <LoadButton label="Load Market Value" onClick={onLoad} isLoading={false} isLoaded={false} disabled={disabled} />
        </div>
      )}

      {query.isLoading && (
        <p className="text-gray-500 text-sm text-center py-8">Loading market value...</p>
      )}

      {query.error && !isNoData(query) && (
        <p className="text-red-400 text-sm text-center py-4">Error loading market value data</p>
      )}

      {isNoData(query) && (
        <NoDataMessage message="No market value data available for this vehicle" />
      )}

      {query.data?.data?.market_value?.market_value_data?.map((trimData: any, idx: number) => (
        <div key={idx} className="mb-4">
          <p className="text-white font-medium mb-2">{trimData.trim}</p>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-gray-400 text-left">
                  <th className="pb-2">Condition</th>
                  <th className="pb-2">Trade-In</th>
                  <th className="pb-2">Private Party</th>
                  <th className="pb-2">Dealer Retail</th>
                </tr>
              </thead>
              <tbody>
                {trimData['market value']?.map((row: any, rowIdx: number) => (
                  <tr key={rowIdx} className={`border-t border-white/10 ${
                    row.Condition === 'Outstanding' ? 'text-green-400' :
                    row.Condition === 'Clean' ? 'text-blue-400' :
                    row.Condition === 'Average' ? 'text-yellow-400' :
                    'text-red-400'
                  }`}>
                    <td className="py-2">{row.Condition}</td>
                    <td className="py-2">{row['Trade-In']}</td>
                    <td className="py-2">{row['Private Party']}</td>
                    <td className="py-2">{row['Dealer Retail']}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
}
